// Header.js
import "fomantic-ui-css/semantic.css";
import { useEffect, useRef, useState } from "react";
import { Activity, Bell, HelpCircle, Mail, Search } from "react-feather";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logo_icon from "../assets/okidoki-o-grey.png";
import logo from "../assets/okidoki-grey.png";
import missionControlStatic from "../assets/mc-icon-static.png";
import missionControlAnimated from "../assets/mission-control-icon.gif";
import { AUTHORITY_TYPE, FORMS, MODULES } from "../const";
import useAuthority from "../hooks/useAuthority";
import CustomizedModal from "./help-center/CustomizedModal";
import HelpCenterHome from "./help-center/HelpCenterHome";
import Modal from "./Modal";
import ActionCenterModal from "./notification/ActionCenterModal";
import MailBoxModal from "./notification/MailBoxModal";
import NotificationDropDown from "./NotificationDropDown";
import RegisterDevices from "./RegisterDevices";
import GlobalCustomerForm from "./stakeholder/GlobalCustomerModal";
import useProfilePicture from "../hooks/useProfilePicture";
import UserAccount from "./UserAccount";
import UserDropDown from "./UserDropDown";

function Header({
  isSearchVisible,
  setIsSearchVisible,
  onSearchToggle,
  isSidebarCollapsed,
}) {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [searchInputFocused, setSearchInputFocused] = useState(false);
  const [acKey, setAcKey] = useState(Date.now());
  const notificationCount = useSelector((state) => state.notification.count);
  const navigate = useNavigate();
  const location = useLocation();
  const modalRef = useRef(null);
  const actionCenterRef = useRef(null);
  const helpCenterRef = useRef(null);
  const mailBoxCenterRef = useRef(null);
  const [selectedKey, setSelectedKey] = useState(null); //for help center
  const [query, setQuery] = useState(""); //for help center
  const [searchClicked, setSearchClicked] = useState(false); //for help center
  const userDetails = useSelector((state) => state.user.userDetails);
  const profilePicUrl = useProfilePicture(userDetails?.uploadDocumentSeq);
  const auth = useSelector((state) => state.user.permissions[MODULES?.Master]);
  const transAuth = useSelector((state) => state.user.permissions[MODULES?.Transaction]);
  const viewNotificationPermission = auth?.NOTIFICATION_TOGGLE?.FORM?.VIEW;
  const helpCenterPermission = auth?.[FORMS?.HELP_CENTER?.HELP_CENTER?.form];
  const actionCenterPermission = FORMS?.ACTION_CENTER?.ACTION_CENTER?.form;
  const outBoxPermission = FORMS?.OUTBOX?.OUTBOX?.form;
  const viewArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.VIEW;
  const headerActionCenter = actionCenterPermission
    ? transAuth?.[actionCenterPermission]
    : {};
  const headerOutBox = outBoxPermission ? transAuth?.[outBoxPermission] : {};
  const viewActionCenterPermission = headerActionCenter?.FORM?.VIEW;
  const viewOutBoxPermission = headerOutBox?.FORM?.VIEW;
  console.log(
    "actionCenter",
    actionCenterPermission,
    viewActionCenterPermission,
    transAuth,
  );

  const [userAccountOpen, setUserAccountOpen] = useState(false);
  const gcRef = useRef(null);
  const gcContentRef = useRef(null);

  const openUserAccount = () => setUserAccountOpen(true);
  const closeUserAccount = () => setUserAccountOpen(false);
  const [gcKey, setGcKey] = useState(0);

  const openGlobalCustomer = () => {
    setGcKey((k) => k + 1); // force a fresh mount each open
    gcRef.current?.showModal();
  };

  const closeGlobalCustomer = () => {
    setGcKey((k) => k + 1); // ensure next open is fresh even if user typed & closed
    gcRef.current?.close();
  };

  const anyModalOpen = userAccountOpen || !!gcRef.current?.open;

  const openModel = () => {
    modalRef.current?.showModal();
  };

  const registerDeviceRef = useRef();

  const { view } = useAuthority({
    type: AUTHORITY_TYPE.FORM,
    module: MODULES.Transaction,
    form: FORMS.MISSION_CONTROL.MC.form,
    editMode: false,
    authenticated: true,
  });

  const handleBellClick = () => {
    setShowNotifications(!showNotifications);
    setShowUserDropdown(false);
  };

  const handleUserClick = () => {
    setShowUserDropdown(!showUserDropdown);
    setShowNotifications(false);
  };

  const handleSearchClick = () => {
    setIsSearchVisible(!isSearchVisible);
    onSearchToggle(); // Call the function to toggle the visibility of the Search component
    setSearchInputFocused(!isSearchVisible); // Set focus if the search bar is now visible
  };

  // Function to handle keydown event
  const handleKeyDown = (event) => {
    // Check if the key combination is Ctrl + /
    if (event.ctrlKey && event.key === "/") {
      event.preventDefault(); // Prevent the default behavior (e.g., page scrolling)

      // Call the function to open the search bar and set focus
      setIsSearchVisible(true);
      onSearchToggle();
      setSearchInputFocused(true);
    }
  };

  const openActionCenterModal = () => {
    setAcKey(Date.now());
    actionCenterRef?.current?.showModal();
  };

  const openMailBoxCenterModal = () => {
    mailBoxCenterRef?.current?.showModal();
  };

  const closeMailBoxCenterModal = () => {
    mailBoxCenterRef?.current?.close();
  };

  const closeActionCenterModal = () => {
    actionCenterRef?.current?.close();
  };

  useEffect(() => {
    // Add event listener for keydown
    document.addEventListener("keydown", handleKeyDown);

    // Remove event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isSearchVisible, onSearchToggle, setIsSearchVisible]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Update window width when the component mounts
    const handleResize = () => setWindowWidth(window.innerWidth);

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const notificationsRef = useRef(null);
  const userDropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const [openRegisterDevices, setOpenRegisterDevices] = useState(false);

  const handleClickOutside = (event) => {
     if (event.target?.closest?.("dialog[open]")) {
      return;
    }
    if (
      notificationsRef.current &&
      !notificationsRef.current.contains(event.target)
    ) {
      // Clicked outside the notification container, close notifications
      setShowNotifications(false);
    }
    if (
      searchInputRef.current &&
      !searchInputRef.current.contains(event.target)
    ) {
      // Clicked outside the search input, reset focus
      setSearchInputFocused(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOpenRegisterDevices = () => {
    setOpenRegisterDevices(true);
    registerDeviceRef.current?.gridLoad();
  };

  const openHelpCenter = () => {
    helpCenterRef?.current?.showModal();
  };

  const closeHelpCenter = () => {
    setSelectedKey(null);
    setQuery("");
    setSearchClicked(false);
    helpCenterRef?.current?.close();
  };

  return (
    <div className="page-header">
      <RegisterDevices
        openModel={openRegisterDevices}
        setCloseModel={setOpenRegisterDevices}
        ref={registerDeviceRef}
      />
      <img
        src={isSidebarCollapsed ? logo_icon : logo}
        alt="logo"
        className="logo"
        style={{
          display: windowWidth <= 500 ? "none" : "flex",
          width: isSidebarCollapsed ? "30px" : "120px",
          transition: "0.3s ease-out",
          cursor: "pointer",
        }}
        onClick={() => {
          navigate("/");
        }}
      />
      <img
        src={logo_icon}
        alt="logo-icon"
        className="logo-icon"
        style={{
          display: windowWidth <= 500 ? "flex" : "none",
          cursor: "pointer",
        }}
        onClick={() => {
          navigate("/");
        }}
      />
      <div
        className="ui icon input"
        style={{
          display: windowWidth <= 500 ? "none" : "flex",
          visibility: isSearchVisible ? "visible" : "hidden",
        }}
        onClick={handleSearchClick}
      >
        <input
          type="text"
          placeholder="Search..."
          className="header-input"
          ref={searchInputRef}
          readOnly={!searchInputFocused} // Make the input readOnly if not focused
        />
        <i className="search icon"></i>
      </div>
      <div
        className="header-admin"
        style={{ display: windowWidth <= 500 ? "none" : "flex", gap: "20px" }}
      >
        {/*<div>*/}
        {/*  <Disc*/}
        {/*    size={25}*/}
        {/*    onClick={handleOpenRegisterDevices}*/}
        {/*    className="bell"*/}
        {/*  />*/}
        {/*</div>*/}
        {view && (
          <div className="header-mission-control">
            <img
              src={
                location.pathname === "/mission-control"
                  ? missionControlAnimated
                  : missionControlStatic
              }
              alt={"mission-control"}
              className={
                location.pathname === "/mission-control"
                  ? "mc-icon"
                  : "mc-icon-static"
              }
              onClick={() => {
                navigate("/mission-control");
              }}
            />
          </div>
        )}

        {viewArticlePermission && (
          <HelpCircle size={25} onClick={openHelpCenter} className="bell" />
        )}
        {viewActionCenterPermission && (
          <div className="header-mission-control">
            <Activity
              size={25}
              onClick={openActionCenterModal}
              className="bell"
            />
            <Modal ref={actionCenterRef} minWidth={"450px"} minHeight={"300px"}>
              <h3 className={"ui dividing header"}>Action Center</h3>
              <ActionCenterModal key={acKey} />
            </Modal>
          </div>
        )}
        {viewOutBoxPermission && (
          <div className="header-mission-control">
            <Mail size={25} onClick={openMailBoxCenterModal} className="bell" />
            <Modal
              ref={mailBoxCenterRef}
              minWidth={"100%"}
              minHeight={"90%"}
              maxHeight={"99%"}
              style={{ overflow: "hidden", padding: 0 }}
            >
              <MailBoxModal />
            </Modal>
          </div>
        )}
        {viewNotificationPermission && (
          <div className="header-admin-item" ref={notificationsRef}>
            <div className="header-notification-icon">
              <Bell size={25} onClick={handleBellClick} className="bell" />
              <label className="notification-count">
                {notificationCount > 100 ? "99+" : notificationCount}
              </label>
            </div>
            <div className="header-notifications">
              <NotificationDropDown showNotifications={showNotifications}
              setShowNotifications={setShowNotifications} openActionCenter={openActionCenterModal} />
            </div>
          </div>
        )}
        <div className="header-user">
          <div
            className="circle-profile"
            onClick={handleUserClick}
            style={
              profilePicUrl
                ? {
                    backgroundImage: `url(${profilePicUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }
                : {}
            }
          ></div>
          {showUserDropdown && (
            <UserDropDown
              setShowUserDropdown={setShowUserDropdown}
              openModal={openModel}
              handleOpenRegisterDevices={handleOpenRegisterDevices}
              // 🔶 pass triggers down
              openUserAccount={openUserAccount}
              openGlobalCustomer={openGlobalCustomer}
              anyModalOpen={anyModalOpen}
            />
          )}
        </div>
        {/* MUI UserAccount modal stays exactly as you had it */}
        <UserAccount open={userAccountOpen} handleClose={closeUserAccount} />

        {/* 🔶 Global Customer Modal (your custom <Modal>) lives HERE */}
        <Modal
          ref={gcRef}
          minWidth={"60vw"}
          minHeight={""}
          closeButton
          clickOutSide={false} // don’t auto-close on backdrop/padding
          onCloseCleanUp={() => {
            /* optional cleanup */
          }}
        >
          <div
            ref={gcContentRef}
            // keep clicks on content from landing on <dialog> padding
            onClick={(e) => e.stopPropagation()}
            style={{
              border: "1px solid rgb(218, 218, 218)",
              padding: 16,
              boxSizing: "border-box",
            }}
          >
            <GlobalCustomerForm
              key={gcKey}
              mountNode={gcContentRef.current}
              onClose={closeGlobalCustomer}
            />
          </div>
        </Modal>
      </div>

      {/* after screen size reduced less than 400px */}
      <div
        style={{
          display: windowWidth <= 500 ? "flex" : "none",
          alignItems: "baseline",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <div className="header-admin">
          <div className="header-search-icon" onClick={handleSearchClick}>
            <Search size={20} />
          </div>
          {viewNotificationPermission && (
            <div className="header-admin-item">
              <div className="header-notification-icon">
                <Bell size={20} onClick={handleBellClick} className="bell" />
                <label className="notification-count">4</label>
              </div>
              <div className="header-notifications">
                <NotificationDropDown showNotifications={showNotifications} setShowNotifications={setShowNotifications} openActionCenter={openActionCenterModal} />
              </div>
              <div className="header-notifications">/</div>
            </div>
          )}
          <div className="header-user" ref={userDropdownRef}>
            <div
              className="circle-profile"
              style={
                profilePicUrl
                  ? {
                      backgroundImage: `url(${profilePicUrl})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }
                  : {}
              }
            ></div>
            {showUserDropdown && (
              <UserDropDown setShowUserDropdown={setShowUserDropdown} />
            )}
          </div>
        </div>
      </div>
      <CustomizedModal
        ref={helpCenterRef}
        minWidth={"100%"}
        minHeight={"100%"}
        closeButton={selectedKey === 3 ? false : true}
        onCloseCleanUp={closeHelpCenter}
      >
        <HelpCenterHome
          selectedKey={selectedKey}
          setSelectedKey={setSelectedKey}
          query={query}
          setQuery={setQuery}
          searchClicked={searchClicked}
          setSearchClicked={setSearchClicked}
        />
      </CustomizedModal>
    </div>
  );
}

export default Header;
